<template>
  <div class="query-notice-container">
    <h2 class="query-notice-title">{{ systemName }}权属证明查询服务大厅须知及协议</h2>
    <p>
      欢迎使用{{ systemName }}查询系统。
      <!-- <span class="text-red"> -->
      为方便公众申请不动产登记，现开通网上查询功能。申请人在申请前须仔细阅读本须知。
      <!-- </span> -->
    </p>
    <p>一、不动产产权在省内的，均可服务大厅查询办理。</p>
    <p>二、服务大厅采用实名制，申请人必须为不动产权利人本人及其未成年子女。</p>
    <p>三、服务大厅必须填写《不动产权属证明查询申请》。</p>
    <p>四、本查询记录的信息为房屋登记信息或房地登记信息。</p>
    <p>五、服务大厅查询后，可以在线下载查询结果记录并可以加盖电子查询签章。</p>
    <p>六、服务大厅不收取任何手续费。</p>
    <div class="text-center mt-30">
      <el-checkbox name="type" v-model="check">我已阅读以上须知并同意</el-checkbox>
    </div>
    <div class="text-center mt-30">
      <el-button @click="next" type="primary" :disabled="disabled">下一步</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'queryNotice',
  data() {
    return {
      systemName: window.CONFIG.APP_INFO.systemName,
      check: false,
    };
  },
  methods: {
    next() {
      this.$emit('next', 1);
    },
  },
  mounted() {},
  computed: {
    disabled() {
      return !this.check;
    },
  },
};
</script>

<style lang="scss" scoped>
.mt-30 {
  margin-top: 30px;
}

/deep/ .el-checkbox__label {
  display: inline;
}

.el-checkbox,
.el-checkbox__input {
  display: inline;
}

.query-notice-container {
  margin: 20px 0;
  padding: 20px 140px;
  // background-color: #FFFFFF;
  text-indent: 25px;
  font-size: 13px;

  .query-notice-title {
    background-color: #f6f8fb;
    height: 74px;
    line-height: 74px;
    text-align: center;
    font-size: 18px;
    color: #101010;
    font-family: SourceHanSansSC-regular;
  }
}

h2 {
  margin: 20px 0;
}

p {
  line-height: 50px;
}

.text-red {
  color: red;
}
</style>
